module.exports = __webpack_public_path__ + "img/312.a6340789.jpg";